import {getIPFromIPSB, getIPFromVORE, getIPFromAIQIYI, getIPFromBAIDUBCE} from './getIpInfo'

/**
 * 轮流调用不同的IP获取方法，直到获取成功为止
 * @returns {Promise<Object>} IP信息对象，包含ip、country、province、city、area、isp等字段
 */
export async function getIpInfo() {
    console.log('------------------getipinfo-----------------')
    
    // 按顺序尝试不同的IP获取方法
    const methods = [
        getIPFromAIQIYI,
        getIPFromVORE,
        getIPFromBAIDUBCE,
        getIPFromIPSB
    ];

    for (const method of methods) {
        try {
            const result = await method();
            if (result && result.ip) {
                // 将结果保存到 sessionStorage
                sessionStorage.setItem('ipInfo', JSON.stringify(result));
                return result;
            }
        } catch (error) {
            console.error(`Error in ${method.name}:`, error);
            continue;
        }
    }

    // 如果所有方法都失败，返回默认值
    return {
        ip: '',
        country: '',
        province: '',
        city: '',
        area: '',
        isp: ''
    };
}